import { Component } from '@angular/core';

@Component({
  selector: 'pc-footer-logo',
  standalone: true,
  imports: [],
  templateUrl: './footer-logo.component.html',
  styleUrl: './footer-logo.component.scss'
})
export class FooterLogoComponent {

}
